import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  CircularProgress,
  Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import savedConfigsService from '../services/savedConfigsService';

export default function MyConfigsDialog({ open, onClose, hashes, onLoad, onDelete }) {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      loadUserConfigs();
    }
  }, [open]);

  const loadUserConfigs = async () => {
    setLoading(true);
    try {
      const userConfigs = await savedConfigsService.getUserConfigs();
      setConfigs(userConfigs);
    } catch (error) {
      console.error('Error loading user configs:', error);
      setConfigs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (configId) => {
    try {
      await savedConfigsService.deleteConfig(configId);
      setConfigs(configs.filter(cfg => cfg.id !== configId));
      if (onDelete) onDelete(configId);
    } catch (error) {
      console.error('Error deleting config:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>My Saved Configurations</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress />
          </Box>
        ) : configs.length === 0 ? (
          <Typography>No saved configurations.</Typography>
        ) : (
          <List>
            {configs.map(cfg => (
              <ListItem key={cfg.id} secondaryAction={
                <IconButton edge="end" onClick={() => handleDelete(cfg.id)}>
                  <DeleteIcon />
                </IconButton>
              }>
                <ListItemText
                  primary={cfg.name}
                  secondary={
                    <>
                      <Typography variant="caption">
                        Type: {cfg.cableType} | Created: {new Date(cfg.createdAt).toLocaleString()}
                        {cfg.accessCount > 0 && ` | Accessed: ${cfg.accessCount} times`}
                      </Typography>
                    </>
                  }
                />
                <Button onClick={() => onLoad(cfg.id)} sx={{ ml: 2 }}>Load</Button>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
} 